export type ContactTopic = 'sales' | 'support' | 'security' | 'press';

/**
 * Topic → published address. `admin@syncanix.com` is the general monitored
 * inbox that handles support / security / press.
 *
 * OPERATOR DIRECTIVE 2026-07-16: a dedicated `sales@syncanix.com` mailbox now
 * exists as the sales/billing contact — every "Contact sales" CTA across the
 * marketing site and dashboard billing surface routes sales enquiries here (via
 * the /contact form's Sales topic + its fallback). This reverses the earlier
 * 2026-06-12 "single inbox only" stance for the sales topic specifically;
 * support/security/press stay on `admin@`. `sales@` is a live, monitored
 * alias that FORWARDS to `admin@syncanix.com` (the single monitored inbox), so
 * sales leads land where they are read — no separate mailbox to watch.
 * `published-emails-truth.test.ts` guards that support@/security@ stay dead.
 */
export const SINGLE_INBOX = 'admin@syncanix.com';

export const SALES_INBOX = 'sales@syncanix.com';

export const CONTACT_ADDRESSES: Readonly<Record<ContactTopic, string>> = {
  sales: SALES_INBOX,
  support: SINGLE_INBOX,
  security: SINGLE_INBOX,
  press: SINGLE_INBOX,
};
